import React from "react";
import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";



const CustomDomainFields = ({
  dynamicDomain,
  ele,
  register,
  setValue,
  clearErrors,
  setError,
  errors,
  propsData,
  setDynamicDomain,
  isDisabled,
  companyAddress,
  showOnlyInputs,
  showOnlyAddBtn,
}) => {
  //function for adding dynamic fields
  const handleAddInput = (index) => {
    const newObj = {
      [`allowedDomain-${index}`]: "",
    };
    setDynamicDomain([...dynamicDomain, newObj]);
  };

  //function for delete dynamic input fields
  const handleDeleteInput = (index) => {
    const newArray = [...dynamicDomain];
    newArray.splice(index - 1, 1);
    setDynamicDomain(newArray);
  };

  // function for handle change dynamic field
  const handleDynaminInputChange = (event, index) => {
    let { name, value } = event.target;
    clearErrors(`allowedDomain-${index}`);
    let onChangeValue = [...dynamicDomain];

    onChangeValue[index][name] = value;
    setDynamicDomain(onChangeValue);
  };

  if (showOnlyAddBtn) {
    return (
      <Box className="justifyEnd">
        <Box>
          <Typography
            variant="body2"
            className="fw400 pt10 justifyCenter"
            role="presentation"
            onClick={() => handleAddInput(dynamicDomain?.length)}
            style={{ cursor: "pointer" }}
          >
            <Typography variant="head4" component="span" className="colorBlue pr10">
              +
            </Typography>
            Add Domain
          </Typography>
        </Box>
        <Box className="ml20">
          {dynamicDomain?.length > 1 &&
            (!companyAddress || dynamicDomain.length > companyAddress.length) && (
              <Typography
                variant="body2"
                className="fw400 pt10 alignItem onBoardDeleteBtn"
                role="presentation"
                onClick={() => handleDeleteInput(dynamicDomain?.length)}
                style={{ cursor: "pointer" }}
              >
                <span className="pr10">
                  <DeleteOutlinedIcon role="presentation" />
                </span>
                Delete
              </Typography>
            )}
        </Box>
      </Box>
    );
  }

  const renderInputs = (
    <Box className="mb10">
      <Box className="mb10">
        <Typography className="fw600 " variant="body1">
          Email Provider Details <span className="colorRed">*</span>
        </Typography>
      </Box>

      <Box>
        <Grid
          container
          spacing={{ md: 2 }}
          columns={{ xs: 1, sm: 3, md: 12 }}
        >
          {dynamicDomain?.map((data, index) => (
            <Grid item xs={12} key={index}>
              <Box className="customTextField">
                <TextField
                  name={`allowedDomain-${index}`}
                  placeholder="Enter Email.com"
                  {...register(`allowedDomain-${index}`, {
                    required: true,
                  })}
                  type="text"
                  onChange={(event) => handleDynaminInputChange(event, index)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <MailOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {errors[`allowedDomain-${index}`] && (
                  <Typography variant="body2" className="errorMessage">
                    This field is required
                  </Typography>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );

  if (showOnlyInputs) {
    return renderInputs;
  }

  return (
    <Grid className="mb20">
      {renderInputs}

      <Box className="justifyEnd">
        <Box>
          <Typography
            variant="body2"
            className="fw400 pt20 justifyCenter"
            role="presentation"
            onClick={() => handleAddInput(dynamicDomain?.length)}
            style={{ cursor: "pointer" }}
          >
            <Typography variant="head4" component="span" className="colorBlue pr10">
              +
            </Typography>
            Add Domain
          </Typography>
        </Box>
        <Box className="ml20">
          {dynamicDomain?.length > 1 &&
            (!companyAddress || dynamicDomain.length > companyAddress.length) && (
              <Typography
                variant="body2"
                className="fw400 pt20 alignItem onBoardDeleteBtn"
                role="presentation"
                onClick={() => handleDeleteInput(dynamicDomain?.length)}
                style={{ cursor: "pointer" }}
              >
                <span className="pr10">
                  <DeleteOutlinedIcon role="presentation" />
                </span>
                Delete
              </Typography>
            )}
        </Box>
      </Box>
    </Grid>
  );
};

export default CustomDomainFields;
